exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-interest-investment-___style__footer___13FfN{display:flex;justify-content:center;margin-top:2em}", ""]);

// exports
exports.locals = {
	"footer": "web-flows-interest-investment-___style__footer___13FfN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/interest/investment/style.css
// module id = 1355
// module chunks = 0